export function getCourseStudyRecommendation(courseId, lessons, progress = {}) {
  if (!courseId) return null;

  const courseLessons = lessons
    .filter(lesson => lesson.courseId === courseId && lesson.published && !lesson.special)
    .sort((a, b) => a.order - b.order);
  const lastActivity = progress.lastActivity;

  if (['lesson', 'review', 'reading'].includes(lastActivity?.type)) {
    const lastLesson = courseLessons.find(lesson => lesson.id === lastActivity.lessonId);
    if (lastLesson) return lastLesson;
  }

  return courseLessons.find(lesson => !progress.completedLessons?.[lesson.id]) || null;
}
